var map = {
	"./": 18305,
	"./App": 56138,
	"./App.js": 56138,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Roboto/LICENSE.txt": 25789,
	"./Roboto/Roboto-Black.ttf": 38855,
	"./Roboto/Roboto-BlackItalic.ttf": 88029,
	"./Roboto/Roboto-Bold.ttf": 44886,
	"./Roboto/Roboto-BoldItalic.ttf": 26460,
	"./Roboto/Roboto-Italic.ttf": 81332,
	"./Roboto/Roboto-Light.ttf": 12333,
	"./Roboto/Roboto-LightItalic.ttf": 95364,
	"./Roboto/Roboto-Medium.ttf": 67244,
	"./Roboto/Roboto-MediumItalic.ttf": 1145,
	"./Roboto/Roboto-Regular.ttf": 85163,
	"./Roboto/Roboto-Thin.ttf": 9494,
	"./Roboto/Roboto-ThinItalic.ttf": 91047,
	"./assets/figuritas/carousel/slide1.jpg": 33139,
	"./assets/figuritas/carousel/slide2.jpg": 48994,
	"./assets/figuritas/carousel/slide3.jpg": 39042,
	"./assets/figuritas/carousel/slide4.jpg": 1814,
	"./assets/figuritas/carousel/slide5.jpg": 12290,
	"./assets/figuritas/carousel/slide6.jpg": 46740,
	"./assets/flips/carousel/slide1.jpg": 14513,
	"./assets/global/arrow-down.svg": 43410,
	"./assets/global/colores/1.gif": 34399,
	"./assets/global/colores/1.png": 93872,
	"./assets/global/colores/2.gif": 16629,
	"./assets/global/colores/2.png": 20258,
	"./assets/global/colores/20.gif": 95923,
	"./assets/global/colores/20.png": 46244,
	"./assets/global/colores/3.gif": 82860,
	"./assets/global/colores/3.png": 94952,
	"./assets/global/colores/32.gif": 17340,
	"./assets/global/colores/32.png": 81520,
	"./assets/global/colores/33.gif": 39417,
	"./assets/global/colores/33.png": 87245,
	"./assets/global/colores/34.gif": 16363,
	"./assets/global/colores/34.png": 30492,
	"./assets/global/colores/35.gif": 25817,
	"./assets/global/colores/35.png": 4873,
	"./assets/global/colores/36.gif": 78214,
	"./assets/global/colores/36.png": 27479,
	"./assets/global/colores/38.gif": 74249,
	"./assets/global/colores/38.png": 57353,
	"./assets/global/colores/39.gif": 73589,
	"./assets/global/colores/39.png": 11879,
	"./assets/global/colores/4.gif": 81007,
	"./assets/global/colores/4.png": 92298,
	"./assets/global/colores/40.gif": 79817,
	"./assets/global/colores/40.png": 82633,
	"./assets/global/colores/41.gif": 12926,
	"./assets/global/colores/41.png": 22307,
	"./assets/global/colores/42.gif": 67835,
	"./assets/global/colores/42.png": 29820,
	"./assets/global/insta-logo.png": 85582,
	"./assets/global/pla.jpg": 41815,
	"./assets/global/tiktok-logo.png": 28119,
	"./assets/global/whatsapp-logo.png": 79969,
	"./assets/global/who-we-are.jpg": 91792,
	"./assets/home-slider/1.png": 63891,
	"./assets/home-slider/2.png": 87058,
	"./assets/home-slider/3.png": 31754,
	"./assets/home-slider/4.png": 78425,
	"./assets/home-slider/5.png": 21496,
	"./assets/macetitas/carousel/slide1.jpg": 41893,
	"./assets/macetitas/carousel/slide2.jpg": 96645,
	"./assets/macetitas/carousel/slide3.jpg": 95535,
	"./assets/macetitas/carousel/slide4.jpg": 9612,
	"./assets/macetitas/carousel/slide5.jpg": 32733,
	"./assets/macetitas/carousel/slide6.jpg": 61761,
	"./assets/navigation/cart-logo.svg": 70047,
	"./assets/navigation/logo.png": 70782,
	"./assets/plaquitas/carousel/slide1.jpg": 44155,
	"./assets/plaquitas/carousel/slide2.jpg": 69911,
	"./assets/plaquitas/carousel/slide3.jpg": 44572,
	"./assets/plaquitas/carousel/slide4.jpg": 17205,
	"./assets/plaquitas/carousel/slide5.jpg": 93661,
	"./assets/plaquitas/carousel/slide6.jpg": 62857,
	"./assets/plaquitas/formas/circulo.svg": 54115,
	"./assets/plaquitas/formas/corazon.svg": 54154,
	"./assets/plaquitas/formas/estrella.svg": 32901,
	"./assets/plaquitas/formas/hueso.svg": 9470,
	"./assets/plaquitas/formas/pez.svg": 36268,
	"./assets/plaquitas/formas/rectangulo.svg": 77553,
	"./assets/plaquitas/formas/rombo.svg": 93168,
	"./components/Carousel": 75931,
	"./components/Carousel.js": 75931,
	"./components/ColorPicker": 52009,
	"./components/ColorPicker.js": 52009,
	"./components/Footer": 40642,
	"./components/Footer.jsx": 40642,
	"./components/HomeNavigation": 75367,
	"./components/HomeNavigation.js": 75367,
	"./components/HomeSlider": 36893,
	"./components/HomeSlider.js": 36893,
	"./components/ScrollToTop": 7788,
	"./components/ScrollToTop.jsx": 7788,
	"./components/TellUsYourIdea": 89588,
	"./components/TellUsYourIdea.js": 89588,
	"./components/TopBar": 9054,
	"./components/TopBar.js": 9054,
	"./components/carousel.scss": 26479,
	"./components/colorPicker.scss": 49152,
	"./components/footer.scss": 33754,
	"./components/homeNavigation.scss": 56622,
	"./components/homeSlider.scss": 63578,
	"./components/previews/Circulo": 74701,
	"./components/previews/Circulo.js": 74701,
	"./components/previews/Corazon": 78361,
	"./components/previews/Corazon.js": 78361,
	"./components/previews/Estrella": 29963,
	"./components/previews/Estrella.js": 29963,
	"./components/previews/Hueso": 11053,
	"./components/previews/Hueso.js": 11053,
	"./components/previews/Pez": 4230,
	"./components/previews/Pez.js": 4230,
	"./components/previews/Rectangulo": 80640,
	"./components/previews/Rectangulo.js": 80640,
	"./components/previews/Rombo": 41948,
	"./components/previews/Rombo.js": 41948,
	"./components/previews/circulo.scss": 10539,
	"./components/previews/corazon.scss": 16957,
	"./components/previews/estrella.scss": 99660,
	"./components/previews/hueso.scss": 28842,
	"./components/previews/pez.scss": 87329,
	"./components/previews/rectangulo.scss": 34318,
	"./components/previews/rombo.scss": 87792,
	"./components/tellUsYourIdea.scss": 38130,
	"./components/topBar.scss": 93425,
	"./components/uploadPhoto": 60354,
	"./components/uploadPhoto.jsx": 60354,
	"./components/uploadPhoto.scss": 37637,
	"./data/figuritas": 33152,
	"./data/figuritas.json": 33152,
	"./data/flips": 51696,
	"./data/flips.json": 51696,
	"./data/macetitas": 35793,
	"./data/macetitas.json": 35793,
	"./data/plaquitas": 52155,
	"./data/plaquitas.json": 52155,
	"./index": 18305,
	"./index.js": 18305,
	"./noteworthy/Noteworthy-Bold.ttf": 14241,
	"./pages/Carrito": 50308,
	"./pages/Carrito.js": 50308,
	"./pages/Figuritas": 94358,
	"./pages/Figuritas.js": 94358,
	"./pages/Flips": 78011,
	"./pages/Flips.js": 78011,
	"./pages/Home": 91266,
	"./pages/Home.js": 91266,
	"./pages/Macetitas": 32715,
	"./pages/Macetitas.js": 32715,
	"./pages/Plaquitas": 36083,
	"./pages/Plaquitas.js": 36083,
	"./pages/carrito.scss": 41199,
	"./pages/figuritas.scss": 57725,
	"./pages/flips.scss": 29456,
	"./pages/home.scss": 64260,
	"./pages/macetitas.scss": 71352,
	"./pages/plaquitas.scss": 59072,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./styles.scss": 54803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;